module.exports = __webpack_public_path__ + "static/img/MRO.0272e2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/main/MRO.png
// module id = t0nF
// module chunks = 1